// extracted by mini-css-extract-plugin
export default {"ContactForm":"ContactForm_ContactForm__0rFbD","succeeded":"ContactForm_succeeded__QgTFJ"};